import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../lib/api';
import OwnerListingCard from './OwnerListingCard';
import { Skeleton } from './ui/skeleton';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight, ArrowRight, User } from 'lucide-react';

const OwnerListingsSection = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [start, setStart] = useState(0);
  const perView = 4;

  useEffect(() => {
    axios.get(`${API}/owner-listings`, { params: { limit: 12 } })
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  if (!loading && items.length === 0) return null;

  const canPrev = start > 0;
  const canNext = start + perView < items.length;

  return (
    <section className="py-14 md:py-20 bg-gradient-to-b from-white to-[#fef2f4]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-2">
            <User className="w-5 h-5 text-[#9a1b2f]" />
            <span className="text-xs font-bold uppercase tracking-widest text-[#9a1b2f]">Directly From Owners</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 tracking-tight">LISTED BY OWNERS</h2>
          <div className="w-16 h-1 bg-[#9a1b2f] mx-auto mt-3 rounded-full" />
          <p className="text-sm text-gray-600 mt-4 max-w-2xl mx-auto">No brokerage, direct owner listings verified by SafeHouse. Connect over WhatsApp instantly.</p>
        </div>

        <div className="text-center mb-6">
          <Link to="/owner-listings" className="text-sm text-gray-600 hover:text-[#9a1b2f]">
            View all <span className="text-[#9a1b2f] font-semibold underline">Owner Listings</span> <ArrowRight className="inline w-3 h-3" />
          </Link>
        </div>

        <div className="relative">
          <div className="mobile-section-scroll md:overflow-hidden">
            {loading ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {Array.from({ length: 4 }).map((_, i) => (
                  <div key={i} className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
                    <Skeleton className="h-32 w-full" />
                    <div className="p-4 space-y-2"><Skeleton className="h-4 w-2/3" /><Skeleton className="h-3 w-1/2" /></div>
                  </div>
                ))}
              </div>
            ) : (
              <div
                className="mobile-section-track grid grid-flow-col auto-cols-[85%] sm:auto-cols-[45%] lg:auto-cols-[24%] gap-4 transition-transform duration-500"
                style={{ transform: `translateX(calc(-${start} * (100% / ${perView} + 1rem / ${perView})))` }}
              >
                {items.map((l) => <OwnerListingCard key={l.id} listing={l} />)}
              </div>
            )}
          </div>
          {items.length > perView && (
            <>
              <button disabled={!canPrev} onClick={() => setStart((s) => Math.max(0, s - 1))} className="hidden md:flex absolute -left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-lg border border-gray-100 items-center justify-center hover:bg-[#9a1b2f] hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-all"><ChevronLeft className="w-5 h-5" /></button>
              <button disabled={!canNext} onClick={() => setStart((s) => Math.min(items.length - perView, s + 1))} className="hidden md:flex absolute -right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-lg border border-gray-100 items-center justify-center hover:bg-[#9a1b2f] hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-all"><ChevronRight className="w-5 h-5" /></button>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default OwnerListingsSection;
